import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

class MessagePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
	}
	
	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen1: newArray
		});
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="icon-speech"></i>&nbsp; SMS</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
				<DropdownToggle caret color="settings">
					Settings
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/message/setup" className="dropdown-item" >SMS Setup</Link>
						<Link to="/message/template" className="dropdown-item" >SMS template</Link>
						<Link to="/message/greetings" className="dropdown-item" >Greeting SMS Setup</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item active">
				<Link to="/message/group" className="nav-link" >Group & Single SMS</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/message/report" className="nav-link" >SMS Report</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/message/SMSlog" className="nav-link" >SMS/Push Log</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default MessagePage;


// WEBPACK FOOTER //
// ./src/views/MessagePage/MessagePage.js